import ReplyApiRequest from "@/apiRequests/resources/communityTalk/replyApiRequest";
import { ReplyPostRequest } from "@/apiRequests/models/communityTalk/replyPostRequest";
import { ReplyGetResponse } from "@/apiRequests/models/communityTalk/replyGetResponse";
import { ReplyGetRequest } from "@/apiRequests/models/communityTalk/replyGetRequest";

export default class ReplyDomain {
	private readonly _replyApiRequest: ReplyApiRequest;

	/**
	 * コンストラクタ。
	 */
	constructor() {
		this._replyApiRequest = new ReplyApiRequest();
	}

	/**
	 * トークルーム投稿APIへのリクエスト。
	 * @param tenantId 取得対象のテナントID。
	 * @param request 投稿リプライリクエスト。
	 */
	public async postReplyData(tenantId: string, request: ReplyPostRequest): Promise<string> {
		return await this._replyApiRequest.postReply(tenantId, request);
	}

	/**
	 * リプライ取得APIへのリクエスト。
	 * @param tenantId 取得対象のテナントID。
	 * @param targetTalkRoomId 取得対象のトークルームID。
	 * @param subjectCd 議題コード
	 * @param limit リプライ取得件数。
	 * @param sortKey ソートキー
	 */
	public async getReplyData(tenantId: string, targetTalkRoomId: string, subjectCd: string, limit: number, sortKey: string | null): Promise<ReplyGetResponse> {
		// APIリクエスト用にデータ成形
		let request: ReplyGetRequest = {
			tenantId: tenantId,
			talkRoomId: targetTalkRoomId,
			count: limit,
			subjectCd: subjectCd,
		};
		if (sortKey) {
			request = {
				...request,
				lastReplySortKey: sortKey,
			};
		}

		try {
			const result = await this._replyApiRequest.getReplies(tenantId, request);
			return result;
		} catch (e) {
			throw new Error();
		}
	}
}
